import { useState } from "react";
import { useMutation } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { checkToken } from "src/service/sessions";

interface IUseCheckTokenProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useCheckToken({ onSuccess, onError }: IUseCheckTokenProps) {
  const { handleError } = useApiError({});
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const {
    data,
    isLoading: isCheckTokenLoading,
    mutateAsync: mutateCheckToken,
  } = useMutation("checkToken", checkToken, {
    onSuccess:
      onSuccess ??
      ((res) => {
        if (res.status === 200) {
          setIsSuccess(true);
        }
      }),
    onError: onError ?? handleError,
  });

  return { isSuccess, isCheckTokenLoading, mutateCheckToken };
}
